// extracted by mini-css-extract-plugin
export default {"root":"main-root_L_QRx","img":"main-img_fdHqS","text":"main-text_HocYQ"};